module.exports = __webpack_public_path__ + "static/media/instructions.e9358b0b.svg";